module.exports = __webpack_public_path__ + "files/9a2073f8ef946b336e7c27862bbf3df1.png";